@if (editable()) {
  <button
    type="button"
    class="block"
    data-test-id="schedule-calendar-available-block"
    [disabled]="disabled() || isInPast()"
    [attr.aria-label]="
      isInPast()
        ? `Past available time ${range()}`
        : `Edit available time ${range()}`
    "
    (click)="edit.emit(block())"
  >
    <ng-container [ngTemplateOutlet]="content" />
  </button>
} @else {
  <div class="block" data-test-id="schedule-calendar-available-block">
    <ng-container [ngTemplateOutlet]="content" />
  </div>
}

<ng-template #content>
  @for (range of preferred(); track $index) {
    <span
      class="preferred flex flex-row items-end"
      data-test-id="schedule-calendar-preferred-range"
      [class.under-delete]="range.isAtBottom && canDelete()"
      [class.under-select]="range.isAtBottom && hasSelectableSlot()"
      [style.top.px]="range.top"
      [style.height.px]="range.height"
    >
      @if (range.showLabel) {
        <span class="preferred-label flex flex-row items-center gap-0.5">
          <mat-icon>star</mat-icon>
          Preferred
        </span>
      }
    </span>
  }
  @if (time()) {
    <span
      class="time"
      [class.under-delete]="isShort() && canDelete()"
      [class.under-select]="isShort() && hasSelectableSlot()"
    >
      {{ time() }}
    </span>
  }
</ng-template>

@if (slot(); as slot) {
  <button
    #slotButton
    type="button"
    class="slot"
    data-test-id="schedule-calendar-available-block-slot"
    aria-keyshortcuts="ArrowUp ArrowDown Home End"
    [style.top.px]="slot.top"
    [style.height.px]="slot.height"
    [attr.aria-label]="`Select time ${slot.label}`"
    [attr.aria-describedby]="slotHintId"
    [attr.aria-disabled]="busy() || null"
    (keydown)="moveKeyboardSlot($event)"
    (click)="confirmSlot(slot.slot)"
  >
    {{ slot.label }}
  </button>
  <span class="slot-hint" [id]="slotHintId">
    Use the up and down arrow keys to change the time
  </span>
} @else if (pendingSlot(); as pending) {
  <div
    class="slot pending flex items-center"
    data-test-id="schedule-calendar-available-block-pending-slot"
    [style.top.px]="pending.top"
    [style.height.px]="pending.height"
  >
    {{ pending.label }}
  </div>
}
@if (hasSelectableSlot()) {
  <button
    #selectButton
    type="button"
    class="select flex"
    title="Select a time"
    data-test-id="schedule-calendar-available-block-select-button"
    [class.short]="isShort()"
    [class.under-slot]="isSelectUnderSlot()"
    [attr.aria-label]="`Select a time in ${range()}`"
    [attr.aria-disabled]="busy() || null"
    (mouseenter)="isOverSelect.set(true)"
    (mouseleave)="isOverSelect.set(false)"
    (click)="startKeyboardSlot()"
  >
    <mat-icon>event_available</mat-icon>
  </button>
}
@if (canDelete()) {
  <button
    type="button"
    class="delete flex"
    title="Delete"
    data-test-id="schedule-calendar-available-block-delete-button"
    [class.short]="isShort()"
    [attr.aria-label]="`Delete available time ${range()}`"
    (click)="delete.emit(block())"
  >
    <mat-icon>delete</mat-icon>
  </button>
}
